import { createEditor } from '@wangeditor/editor';
 
export default class FormatPaint {
	constructor() {
        this.title = '格式刷' // 定义菜单栏标题
        this.iconSvg = '<svg t="1730687976049" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4290" width="200" height="200"><path d="M657.92 335.433143h292.059429v73.142857H181.540571v-73.142857h293.010286v-292.571429h183.369143v292.571429z m-598.308571 660.48c32.914286-45.056 56.758857-83.675429 71.387428-115.858286 21.942857-48.347429 33.133714-56.539429 42.861714-129.974857 6.582857-49.005714 10.093714-138.24 10.825143-267.995429h764.489143v513.755429h-144.164571c-34.230857-31.744-57.344-59.977143-69.485715-84.772571-11.995429-24.795429-23.04-66.998857-33.206857-126.610286-17.115429 59.977143-33.426286 102.180571-48.859428 126.610286-15.506286 24.429714-43.739429 52.662857-84.845715 84.845714H59.465143z" fill="#333333" p-id="4291"></path></svg>'//自定义菜单中格式化刷的图标
        // 这个图标自己去iconFont网站去搜索格式刷然后下载svg图标，使用svg中的代码粘贴到这里即可
        this.tag = 'button'
        if(!FormatPaint.prototype.init){
            FormatPaint.prototype.attrs = {
                isSelect:false,
                formatJson:{},
                formatedHtml:''
            };
            FormatPaint.prototype.init = true;
        }
    }
    getValue(editor) {                           // JS 语法
        return ''
    }
 
    // 菜单是否需要激活（比如选择加粗文本，“加粗”菜单会被激活），用不到会返回 false
    isActive(editor) {         
        return this.attrs.isSelect;
    }
 
    // 菜单是否需要禁用（比如选中 H1 ，“引用”菜单被禁用），用不到会返回 false
    isDisabled(editor) {                     // JS 语法
        return false
    }
 
    // 点击菜单时触发的函数
    exec(editor, value) {    
        if (this.isDisabled(editor)) return 
        const select = editor.getFragment()[0].children[0];
        if(!this.attrs.isSelect&&select.text.length){
            this.attrs.formatJson = {...select};
            this.attrs.isSelect = true;
        }else{
            editor.getSelectionText() 
            this.attrs.isSelect = false;
        }  
        editor.blur()
        editor.focus()                       // JS 语法
    }
    //设置格式化好的内容
    setFormatHtml(editor){
        if(!this.attrs.formatedHtml.length) return;
        editor.dangerouslyInsertHtml(this.attrs.formatedHtml)
        this.attrs.formatedHtml = ''
    }
}
 
 
export function withSelect(editor) {  
   const myFormatPaint =  new FormatPaint ;
 
    const { onChange,onBlur,onFocus} = editor // 获取当前 editor API
    const newEditor = editor
 
    
    newEditor.onChange = (editor)=>{
        onChange();
        if(myFormatPaint.attrs.isSelect){
            myFormatPaint.attrs.formatJson.text = newEditor.getSelectionText()
                const _editor = createEditor({
                    content: [myFormatPaint.attrs.formatJson]
                })
                myFormatPaint.attrs.formatedHtml = _editor.getHtml();
                if(!document.onmouseup){
                    document.onmouseup=()=>{
                        if(!myFormatPaint.attrs.formatedHtml.length) return;
                        myFormatPaint.setFormatHtml(newEditor)
                        document.onmouseup = null
                    }
              }
        }
        return;
    }
    return newEditor
}